import { StyleSheet } from 'aphrodite/no-important';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (showVoiceOver: boolean) => {
  return StyleSheet.create({
    showIfDesktop: {
      display: 'none',
      [media.desktop]: {
        display: 'block',
      },
    },
    keynoteVideo: {
      margin: 'auto',
      marginBottom: '45px',

      [media.desktop]: {
        width: 874,
        marginBottom: 60,
      },
    },

    streamingVideoContainer: {
      position: 'relative',
      display: 'block',
      width: '100%',
    },

    videoInfo: {
      marginTop: '21px',
      marginBottom: '15px',
      paddingBottom: '16px',

      [media.tablet]: {
        borderBottom: '1px solid #E60012',
        paddingBottom: '18px',
        marginTop: '27px',
      },
      [media.desktop]: {
        marginTop: '30px',
      },
    },

    videoTitle: {
      color: '#fff',

      [children('span')]: {
        display: 'inline',

        ':after': {
          content: '"|"',
          margin: '0 10px',
          color: '#E60012',
          fontWeight: 'normal',
        },
      },
      [children('span:last-child')]: {
        ':after': {
          content: '""',
          margin: '0',
          fontWeight: 'normal',
        },
      },
    },
    headlineContainer: {
      width: '100%',
      display: 'flex',
      flexWrap: 'nowrap',
      flexDirection: 'column-reverse',
      justifyContent: 'space-between',
      marginBottom: '16px',
      [media.tablet]: {
        marginBottom: '18px',
      },
      [media.desktop]: {
        flexDirection: 'row',
      },
    },
    headlineInfo: {
      display: 'flex',
      flexGrow: 1,
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    headlineTitle: {
      display: 'inline-block',
      marginRight: '10px',
      fontSize: '16px',
      lineHeight: '20px',
      [children('span')]: {
        fontWeight: 'bold',
      },

      [media.tablet]: {
        fontSize: '20px',
        lineHeight: '24px',
      },
      [media.desktop]: {
        fontSize: '24px',
        lineHeight: '24px',
      },
    },
    bioButtonTablet: {
      display: 'none',

      [media.tablet]: {
        display: 'inline-block',
        width: 'fit-content',
        whiteSpace: 'nowrap',
        padding: '0px 15px',
      },
      [media.desktop]: {
        display: 'none',
      },
    },
    bioButtonDesktopAndMobile: {
      fontSize: '16px',
      lineHeight: '22px',
      width: '100%',

      [media.tablet]: {
        display: 'none',
      },
      [media.desktop]: {
        display: 'inline-block',
        width: 'fit-content',
        whiteSpace: 'nowrap',
      },
    },

    subheadlineRowContainer: {
      display: 'flex',
      flexWrap: 'nowrap',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      [children(' > *:first-child')]: {
        marginRight: 10,
      },
    },
    subheadlineContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    subheadlineButton: {
      flexGrow: 1,
      [children('button')]: {
        width: 'fit-content',
      },
    },

    additionalSpeakers: {
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 'normal',
      ':not(:first-child)': {
        marginTop: '11px',
      },
      [children('span:first-child')]: {
        fontWeight: 'bold',
      },

      [media.tablet]: {
        fontSize: '16px',
        lineHeight: '22px',
      },
    },

    voiceOverBadge: {
      width: 'fit-content',
      background: 'transparent',
      color: palette.red,
      fontWeight: 'bold',
      fontSize: '12px',
      lineHeight: '22px',
      wordBreak: 'keep-all',

      [media.tablet]: {
        fontSize: '14px',
        lineHeight: '22px',
      },
      [media.desktop]: {
        background: palette.red,
        color: '#FFF',
        padding: '5px 8px',
        borderRadius: 5,
        fontSize: '16px',
        lineHeight: '22px',
      },
    },

    hr: {
      borderLeft: 0,
      borderRight: 0,
      borderBottom: 0,
      borderTop: '1px solid #E60012',
      margin: '16px 0px',
      [media.tablet]: {
        margin: '18px 0px',
      },
    },
  });
};
